module.exports = __webpack_public_path__ + "img/Home BESS 2.55db682d.svg";